module.exports = __webpack_public_path__ + "static/media/head.3482ab28.svg";